import React from "react";

// material ui
import { withStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Menu from '@material-ui/core/Menu';

import { BaseComponent } from "shared/components";
import { titleCasePipe } from "shared/pipes";

import { YellowButton, OrangeButton, GreenButton } from "./helper";


const useStyles = {
    grid: {
        margin: '15px'
    },
};

class StatusDropdown extends BaseComponent {

    DEFAULT_VALUE = 'To Process';
    optionButtons = {
        'investigate': OrangeButton,
        'charged': GreenButton,
        'missing': YellowButton
    };

    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            value: this.DEFAULT_VALUE
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    onChange(option) {
        let stateUpdated = { anchorEl: null };
        if (this.props.onChange) {
            this.props.onChange(option, (isChanged) => {
                if (isChanged) {
                    stateUpdated['value'] = option;
                }

                this.setState(stateUpdated);
            });
        } else {
            this.setState(stateUpdated);
        }
    }

    renderMenuButton(value) {
        const OptionButton = this.optionButtons[value] ? this.optionButtons[value] : YellowButton;

        return <OptionButton fullWidth={true} variant="contained"
            aria-controls={this.props.id} aria-haspopup="true" onClick={this.handleClick}>
            {value}
        </OptionButton>
    }

    renderOptionButton(option) {
        const OptionButton = this.optionButtons[option];

        return <OptionButton
            key={option}
            variant="contained"
            fullWidth={false}
            onClick={() => this.onChange(option)}>{titleCasePipe.transform(option)}</OptionButton>
    }

    render() {
        const { classes, id } = this.props;
        const { anchorEl, value } = this.state;
        const options = ['charged', 'investigate'];

        return (
            <div>
                {this.renderMenuButton(value)}
                <Menu
                    id={id}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}>
                    <Grid container className={classes.grid} direction="column" justify="center" alignItems="stretch" spacing={2}>
                        {options.map((option) => (
                            <Grid item key={option}>
                                {this.renderOptionButton(option)}
                            </Grid>
                        ))}
                    </Grid>
                </Menu>
            </div>
        );
    }
}

export default withStyles(useStyles)(StatusDropdown);
